/* 🤖 this file was generated by svg-to-ts */
export const mgcIconXSkewRegular: {
  name: 'x-skew-regular';
  data: string;
} = {
  name: 'x-skew-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.08 3.157a1.611 1.611 0 0 0-.929.794l-.131.267v15.564l.131.267c.147.297.39.538.709.702.439.225.034.287 8.2-1.247 4.048-.761 7.432-1.403 7.52-1.428.297-.084.558-.246.823-.512.307-.307.491-.654.554-1.045.058-.357.058-8.681 0-9.038-.113-.7-.703-1.367-1.377-1.557-.088-.025-3.467-.666-7.509-1.425C4.71 3.118 4.387 3.064 4.08 3.157M12 6.513l6.98 1.311v8.352L12 17.487c-3.839.72-6.984 1.311-6.99 1.311C5.005 18.799 5 15.74 5 12s.005-6.799.01-6.798c.006 0 3.151.591 6.99 1.311"/></svg>`
};
